import React from 'react';
import NavigationButton from './NavigationButton';
import logo from '../images/FullLogo_Transparent_NoBuffer.png';

const SideNavbar = () => {

    return(
        <div className="side-navbar">
            <div className="main-nav-icons">
                <div className="logo-container">
                    <img src={logo} width={200} alt="Watcher" />
                </div>
                <NavigationButton iconName="fa-solid fa-house fa-xl" route="home" title="Home"/>
                <NavigationButton iconName="fa-solid fa-clock fa-xl" route="requests" title="Requests"/>
                <NavigationButton iconName="fa-solid fa-warehouse fa-xl" route="inventory" title="Inventory"/>
                <NavigationButton iconName="fa-solid fa-cart-shopping fa-xl" route="purchase-orders" title="PO's"/>
                <NavigationButton iconName="fa-solid fa-money-bill fa-xl" route="sale-orders" title="SO's"/>
                {/* <NavigationButton iconName="fa-solid fa-arrow-trend-up fa-xl" route="reports" title="Reports"/> */}
            </div>
            <div className="profile-icon">
                <NavigationButton iconName="fa-solid fa-user fa-xl" route="profile" title="Profile"/>
            </div>
        </div>
    )
}

export default SideNavbar;